import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import modalsActions from '@/redux/modals/actions';
import invitesActions from '@/redux/invites/actions';
import { Loader } from '@/components';

const AsyncInviteUser = Loadable({
  loader: () => import('./InviteUser'),
  loading: Loader,
});

const mapStateToProps = ({ modals, invites }) => ({
  ...invites,
  isInviteUserModalOpen: modals.isInviteUserModalOpen,
  tableInvitesData: invites.data.map((invite, index) => {
    return Object.assign(
      {},
      {
        key: index,
        email: invite.email,
        name: invite.name,
        type: invite?.type,
        business_type: invite?.business_type,
        organization: invite?.organization,
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleInviteUserModal: modalsActions.toggleInviteUserModal,
      sendInvite: invitesActions.sendInvite,
      fetchInvites: invitesActions.fetchInvites,
      tableChange: invitesActions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncInviteUser);
